import Vue from 'vue';
import firebase from 'firebase/app';
import { firestorePlugin } from 'vuefire';
import VueMeta from 'vue-meta';
import VueClipboard from 'vue-clipboard2';
import monkey from '@/assets/animoji/monkey.png';
import octopus from '@/assets/animoji/octopus.png';
import dog from '@/assets/animoji/dog.png';
import dragon from '@/assets/animoji/dragon.png';
import mouse from '@/assets/animoji/mouse.png';
import giraffe from '@/assets/animoji/giraffe.png';
import alien from '@/assets/animoji/alien.png';
import bear from '@/assets/animoji/bear.png';
import shark from '@/assets/animoji/shark.png';
import fox from '@/assets/animoji/fox.png';
import tiger from '@/assets/animoji/tiger.png';
import rabbit from '@/assets/animoji/rabbit.png';
import dino from '@/assets/animoji/dino.png';
import ghost from '@/assets/animoji/ghost.png';
import owl from '@/assets/animoji/owl.png';
import panda from '@/assets/animoji/panda.png';
import koala from '@/assets/animoji/koala.png';
import robot from '@/assets/animoji/robot.png';
import unicorn from '@/assets/animoji/unicorn.png';
import cat from '@/assets/animoji/cat.png';
import lion from '@/assets/animoji/lion.png';
import excited from '@/assets/emoji/excited.png';
import smiling from '@/assets/emoji/smiling.png';
import suspicious from '@/assets/emoji/suspicious.png';
import VueTheMask from 'vue-the-mask';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './i18n';


Vue.config.productionTip = false;


firebase.analytics();

Vue.use(firestorePlugin);
Vue.use(VueMeta);
Vue.use(VueTheMask);
Vue.use(VueClipboard);
VueClipboard.config.autoSetContainer = true;

if (window.location.href === 'https://ucime.se/') window.location.replace('https://www.ucime.se');

firebase.auth().onAuthStateChanged((user) => {
  store.dispatch('fetchAuth', user);
  new Vue({
    store,
    router,
    vuetify,
    i18n,
    render: (h) => h(App),
  }).$mount('#app');
});

const animojis = {
  octopus,
  dog,
  dragon,
  mouse,
  giraffe,
  alien,
  bear,
  shark,
  fox,
  tiger,
  monkey,
  rabbit,
  dino,
  ghost,
  owl,
  panda,
  koala,
  robot,
  unicorn,
  cat,
  lion,
};

const emojis = {
  excited,
  smiling,
  suspicious,
};

// eslint-disable-next-line import/prefer-default-export
export { animojis, emojis };
